export default __webpack_public_path__ + "static/media/02.b0be0d50.jpg";